import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '',
      name: 'login',
      component: (resolve) => require(['@/views/LoginIndex.vue'], resolve),
      hidden: true,
      meta: {
        icon: '',
        title: '登录'
      }
    },
    {
      path: '/passwordlessLogin',
      name: 'passwordlessLogin',
      component: (resolve) => require(['@/views/PasswordlessLogin.vue'], resolve),
      hidden: true,
      meta: {
        icon: '',
        title: '免密登录'
      }
    },
    {
      path: '/menu',
      name: 'menu',
      component: (resolve) => require(['@/views/MenuIndex.vue'], resolve),
      hidden: true,
      meta: {
        icon: '',
        title: '系统目录'
      }
    }
  ]
})
